/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { ID } from '@/data/types/Basic';
import { ItnlIntegrationScript } from '@/data/types/ItnlIntegrationScript';
import { WidgetProperties } from '@/data/types/Slot';
import { flowboxScript } from '@/utils/itnlIntegrationScriptsScripts';
import { loadExternalScripts, removeScripts } from '@/utils/loadExternalScripts';
import { Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';

type TagsOperator = 'any' | 'all';

const emptyProperties: Partial<WidgetProperties> = {};

export const FlowboxContentpageRv: FC<{ id: ID; properties?: WidgetProperties; stLocFlowKey?:string }> = ({
	id: _id,
	properties = emptyProperties,
	stLocFlowKey = ""
}) => {
	const [allTags, setAllTags] = useState<string[]>([]);

	const flowboxKey = properties.flowKey ?? stLocFlowKey ?? properties.flowboxKey; //flowboxKey is the variable recieved from commerce composer layouts

	useEffect(() => {
		if (!flowboxKey) return;
		const allTags: string[] = [...document.querySelectorAll<HTMLButtonElement>('button[data-tag]')]
			.map(btn => btn.dataset.tag)
			.filter((tag) => tag !== undefined)
			.slice(1);
		if(allTags.length){
			setAllTags(allTags);
		}
		const scripts: ItnlIntegrationScript[] = [{
			id: "flowbox_init_script",
			scriptContent: allTags.length 
							? flowboxScript(flowboxKey,"COMUNITY_TAG_PAGE" ,allTags) 
							: flowboxScript(flowboxKey,"" ,""),
		}];

		loadExternalScripts(scripts);
		return () => { removeScripts(scripts) }
	}, [flowboxKey]);

	// Dynamic tag button - filter ogic - start
	useEffect(() => {
		let mounted = true;
		const clearButtonClasses =  () => {
			const buttons = document.querySelectorAll<HTMLButtonElement>('button[data-tag]');
			buttons?.forEach(button => button.classList.remove('active'));
		}

		const handleClick = (event: MouseEvent): void => {
			const target = event.target;

			if (!(target instanceof HTMLButtonElement)) return;
			if (!target.matches('div.tags button')) return;

			const rawTag = target.dataset.tag;
			const tag = rawTag === undefined || rawTag === 'true' ? '' : rawTag;
			updateFlow(
				tag === '' ? allTags : tag.split(','),
				tag === '' ? 'any' : 'all'
			);

			clearButtonClasses();
			target.classList.add('active');
		};

		const container = document.querySelector<HTMLElement>('#flowbox-tags');
		if (container && mounted) {
			container.addEventListener('click', handleClick);
		}

		return () => {
			mounted = false;
			if(container)container.removeEventListener('click', handleClick);
		};
	}, [flowboxKey, allTags]);

	useEffect(()=>{
		const allTags: string[] = [...document.querySelectorAll<HTMLButtonElement>('button[data-tag]')]
			.map(btn => btn.dataset.tag)
			.filter((tag) => tag !== undefined)
			.slice(1);
		if(allTags.length){
			setAllTags(allTags);
			updateFlow(allTags, 'all');
		}
	},[]);

	const updateFlow = (tags: string[], tagsOperator: TagsOperator) => {
		window.flowbox('update', {
			key: flowboxKey,
			tags,
			tagsOperator
		});
	}
	// Dynamic tag button - filter ogic - end

	return (
		<Box position="relative">
			<Box id="js-flowbox-flow" className="flowBoxDiv" />
		</Box>
	);
};